import * as React from 'react';
import { useTranslation } from 'react-i18next';
import AiAvatar from './AiAvatar';

type Props = {
  onSuggestionClick: (text: string) => void;
};

const AiChatSuggestions: React.FC<React.PropsWithChildren<Props>> = ({
  onSuggestionClick,
}) => {
  const { t } = useTranslation();
  const suggestions = [
    t('aiChat.suggestions.vacationDays'),
    t('aiChat.suggestions.whoOnLeave'),
    t('aiChat.suggestions.expensePolicy'),
    t('aiChat.suggestions.currentGoals'),
  ];
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '3rem 0',
      }}>
      <AiAvatar size="lg" />
      <p
        style={{
          fontSize: '1rem',
          fontWeight: 500,
          color: 'var(--bs-flair-gray-1, #1d1d1d)',
          margin: 0,
        }}>
        {t('aiChat.suggestions.greeting')}
      </p>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '0.5rem',
          maxWidth: '32rem',
        }}>
        {suggestions.map((text) => (
          <button
            key={text}
            className="ai-chat-suggestion-btn"
            onClick={() => onSuggestionClick(text)}>
            {text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AiChatSuggestions;
